import { LocationTag } from "planning-portal-library/src/lib/core/domain/models/location-tag";
import { LocationTagMlsWebEntity } from "./location-tag-mls-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";

export class LocationTagMlsWebRepositoryMapper extends Mapper<LocationTagMlsWebEntity, LocationTag> {
    mapFrom(param: LocationTagMlsWebEntity): LocationTag {
      return {
        id: param.id,
        name: param.name,
        description: param.description,
        associatedLocations: param.associatedLocations
      };
    }
  
    mapTo(param: LocationTag): LocationTagMlsWebEntity {
      return {
        id: param.id,
      name: param.name,
      description: param.description,
      associatedLocations: param.associatedLocations
    }
  }
}
  